"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  GameControlsInfo,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import * as React from "react";
import GameStatsTable from "./GameStatsTable";
import LiveRtpStrip from "./LiveRtpStrip";

type Props = { game: SingleGameFragment; isLiveRtpEnabled?: boolean };

const GameStatsDrawer: FC<Props> = ({ game, isLiveRtpEnabled }) => {
  const [isOpen, setOpen] = React.useState(false);
  const { t } = useGamePageData();

  const handleOpen = () => setOpen(true);

  return (
    <>
      <GameControlsInfo
        data-testid="info-button"
        aria-label={t("game.stats.infolabel", "Game stats")}
        onClick={handleOpen}
      />
      <Drawer open={isOpen} onOpenChange={setOpen}>
        <DrawerContent className="bg-secondary">
          <DrawerHeader className="text-left">
            <DrawerTitle>{t("game.stats.title", "Game Stats")}</DrawerTitle>
            <DrawerDescription className="sr-only">
              {t(
                "game.stats.description",
                "Payout and betting details for this game.",
              )}
            </DrawerDescription>
          </DrawerHeader>
          <div className="overflow-y-auto px-4 pb-8">
            <LiveRtpStrip game={game} isLiveRtpEnabled={isLiveRtpEnabled} />
            <GameStatsTable game={game} />
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default GameStatsDrawer;
